import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import classNames from 'classnames';
const getGridClasses = (amount) => {
    switch (amount) {
        case 1:
            return 'col-12';
        case 2:
            return 'col-12 col-sm-6';
        case 3:
            return 'col-12 col-md-4';
        case 4:
            return 'col-12 col-md-6 col-lg-3';
        case 6:
            return 'col-12 col-sm-4 col-lg-2';
        case 12:
            return 'col-12 col-sm-1';
        default:
            return 'col-12';
    }
};
const TeaserContainer = (props) => {
    const { className, teaserPerRow, children, columnClassName } = props;
    const rowClassNames = classNames('teaser-container', 'row', 'display-flex-sm flex-wrap-sm', className);
    const columnClassNames = teaserPerRow
        ? getGridClasses(teaserPerRow)
        : getGridClasses(Children.count(children) || 1);
    const aggregatedColumnClassNames = classNames(columnClassNames, columnClassName);
    return (_jsx("div", Object.assign({ className: rowClassNames }, { children: Children.map(children, child => {
            return _jsx("div", Object.assign({ className: aggregatedColumnClassNames }, { children: child }));
        }) })));
};
export default TeaserContainer;
